<template>
  <div class="kpi-grid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'KpiGrid',
}
</script>

<style lang="scss" scoped>
.kpi-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
  // padding-inline: 1rem;
  width: 100%;
}

:deep(.kpi-grid-break) {
  grid-column: 1 / -1;
  height: 0;
}
</style>
